import { FunctionComponent, memo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { IProps } from "./email-body-text.types";
import { Markdown } from "@edgetier/components";
import { captureException } from "@sentry/react";
import "./email-body-text.scss";

/**
 * A component that displays the body text of an email, which may contain markdown.
 * @param text The body text of the email.
 */
const EmailBodyText: FunctionComponent<IProps> = ({ text }) => {
    return (
        <ErrorBoundary
            fallback={
                <p>
                    <div>
                        <div className="email-body-text__error-message">
                            There was a problem when displaying this email. There may be some visual issues.
                        </div>
                        <div>{text.replace(/\n{3,}/g, "\n\n").trim()}</div>
                    </div>
                </p>
            }
            onError={(error) => captureException(error)}
        >
            {<Markdown linkTarget="_blank" markdownString={text.trim()} />}
        </ErrorBoundary>
    );
};

export default memo(EmailBodyText);
